/**
 * Created by Bowen on 10/01/19.
 * Description:
 * firm setting page: make sure specific user is able to edit rel-tree
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { ToastService } from '../../../widgets/toast/toast.service';
import { catchError, filter } from 'rxjs/operators';
import { NotificationStyles } from '../../../widgets/notification/notification.model';
import { SettingScreenService } from '../../../services/setting-screen.service';
import { ManageRelTreeDialogActions } from '../settings.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../redux';
import { userSettingSelector } from '../../../redux/reducers/users.reducer';
import { UsersActionTypes } from '../../../redux/actions/users.actions';

@Component({
    selector: 'tam-manage-relationship-dialog',
    templateUrl: './manage-relationship-dialog.component.html',
    styleUrls: ['./manage-relationship-dialog.component.scss']
})
export class ManageRelationshipDialogComponent implements OnInit, OnDestroy {

    opened = false;
    isPublicAuthorization = true;
    isProgressing = false;
    private _destorySubscription: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _toast: ToastService,
        private _settingScreenService: SettingScreenService,
    ) { }

    ngOnInit() {
        this._destorySubscription.push(
            this._settingScreenService.manageRelDialogActionSubject$.subscribe(action => {
                this._dialogOpenHandler(action);
            }),
        );
    }

    ngOnDestroy() {
        this._destorySubscription.forEach(subscription => subscription.unsubscribe());
    }

    apply() {
        this.isProgressing = true;
        this._settingScreenService.updateRelTreeEditableUsers(this.isPublicAuthorization).pipe(
            catchError((e: any) => {
                this.isProgressing = false;
                return of(null);
            }),
        ).subscribe(res => {
            if (res) {
                this.isProgressing = false;
                this._toast.notify({
                    style: NotificationStyles.Success,
                    message: 'Setting successfully saved.',
                });
                // update store
                this._store.dispatch({
                    type: UsersActionTypes.LOAD_USER_SETTING
                });
                this.opened = false;
            } else {
                this._toast.notify({
                    style: NotificationStyles.Error,
                    message: 'Setting failed saved.',
                });
                this.opened = true;
            }
        });
    }

    cancel() {
        this.opened = false;
    }

    private _dialogOpenHandler(action) {
        if (action.type === ManageRelTreeDialogActions.OPEN) {
            this.opened = true;
            this._store.pipe(
                select(userSettingSelector),
                filter(items => items.length !== 0)
            ).subscribe(userSetting => {
                this._onSubscribeUserSetting(userSetting);
            }).unsubscribe();
        }
    }

    private _onSubscribeUserSetting(userSetting) {
        this.isPublicAuthorization = true;
        if (userSetting && userSetting.relationshipManage) {
            this.isPublicAuthorization = userSetting.relationshipManage.configuration.public;
        }
    }
}
